import { useEffect, useMemo, useState } from "react";
import { api } from "../../../utils/api";
import ExpertiseSelector from "../../common/expertise/selector/ExpertiseSelector";

export default function FieldExpertise({
	clipId,
	initialExpertiseIds = [],
	selectionSeed = 0,
	onChange,
	isDesktop,
}) {
	const [expertises, setExpertises] = useState([]);
	const [activeExpertiseIds, setActiveExpertiseIds] = useState(initialExpertiseIds);
	const [errorMessage, setErrorMessage] = useState("");
	const [isLoadingList, setIsLoadingList] = useState(true);
	const [isLoadingSelection, setIsLoadingSelection] = useState(false);

	useEffect(() => {
		let cancelled = false;
		setIsLoadingList(true);
		setErrorMessage("");
		api
			.expertiseList()
			.then((allExpertises) => {
				if (!cancelled) {
					setExpertises(Array.isArray(allExpertises) ? allExpertises : []);
				}
			})
			.catch((err) => {
				if (!cancelled) {
					setExpertises([]);
					setErrorMessage(
						err?.data?.message || "بارگذاری تخصص‌ها ناموفق بود."
					);
				}
			})
			.finally(() => {
				if (!cancelled) {
					setIsLoadingList(false);
				}
			});
		return () => {
			cancelled = true;
		};
	}, []);

	useEffect(() => {
		let cancelled = false;
		let activeIds = [...(initialExpertiseIds || [])];

		async function resolveSelection() {
			if (clipId == null) {
				setActiveExpertiseIds(activeIds);
				return;
			}
			setIsLoadingSelection(true);
			try {
				const clipResult = await api.listClipExpertises({ clip_id: clipId });
				if (!cancelled && clipResult?.active_expertises?.length) {
					activeIds = clipResult.active_expertises.map((expertise) => expertise.id);
				}
			} catch {
				// بک‌اند قدیمی: از ids برگشتی admin list / فرم استفاده می‌شود
			} finally {
				if (!cancelled) {
					setActiveExpertiseIds(activeIds);
					onChange(activeIds);
					setIsLoadingSelection(false);
				}
			}
		}

		resolveSelection();
		return () => {
			cancelled = true;
		};
	}, [clipId, selectionSeed]);

	const selectedNames = useMemo(() => {
		if (!activeExpertiseIds.length) {
			return [];
		}
		const byId = new Map(expertises.map((item) => [item.id, item.name]));
		return activeExpertiseIds
			.map((id) => byId.get(id))
			.filter(Boolean);
	}, [activeExpertiseIds, expertises]);

	const isLoading = isLoadingList || isLoadingSelection;

	function handleSelectionChange(ids) {
		setActiveExpertiseIds(ids);
		onChange(ids);
	}

	return (
		<div>
			<label className="mb-2 block font-Vazir-700 text-[14px] text-darkBlue">
				تخصص‌ها
			</label>
			{selectedNames.length > 0 && (
				<p className="mb-3 font-Vazir-400 text-[13px] leading-relaxed text-darkBlue/80">
					<span className="font-Vazir-600">انتخاب‌شده:</span>{" "}
					{selectedNames.join("، ")}
				</p>
			)}
			{activeExpertiseIds.length === 0 && !isLoading && (
				<p className="mb-3 font-Vazir-400 text-[13px] text-midGray">
					هنوز تخصصی برای این کلیپ انتخاب نشده است.
				</p>
			)}
			{isLoading && (
				<p className="font-Vazir-400 text-[13px] text-midGray">
					در حال بارگذاری تخصص‌ها…
				</p>
			)}
			{!isLoadingList && expertises.length > 0 && (
				<ExpertiseSelector
					expertises={expertises}
					initActiveExpertiseIds={activeExpertiseIds}
					onChange={handleSelectionChange}
					isDesktop={isDesktop}
				/>
			)}
			{!isLoadingList && expertises.length === 0 && !errorMessage && (
				<p className="font-Vazir-400 text-[13px] text-midGray">
					تخصصی برای انتخاب وجود ندارد.
				</p>
			)}
			{errorMessage && (
				<p className="mt-2 text-center font-Vazir-400 text-[#cc0000] text-[13px]">
					{errorMessage}
				</p>
			)}
		</div>
	);
}
